"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _utils = require("../utils");

/**
 * Vraci query part objekt pro overeni neexistence fieldu.
 */
var notExistsToQuery = function notExistsToQuery(fieldName) {
  return (0, _utils.part)(fieldName, {
    $exists: false
  });
};

var _default = notExistsToQuery;
exports.default = _default;